import { SelectItem } from 'components/inputs/select/select';

import { KEYS } from '../keys';

type Period = (typeof KEYS)[keyof Pick<typeof KEYS, 'PERIOD_AM' | 'PERIOD_PM'>];
export interface ToISOTimeParams {
  hour: string;
  minute: string;
  period: Period;
  timezone: SelectItem;
}

export function toISOTime({ hour, minute, period, timezone }: ToISOTimeParams): string {
  let h = parseInt(hour || '0', 10);
  h = Number.isNaN(h) ? 12 : Math.max(1, Math.min(12, h));

  let m = parseInt(minute || '0', 10);
  m = Number.isNaN(m) ? 0 : Math.max(0, Math.min(59, m));

  if (period === KEYS.PERIOD_PM && h !== 12) h += 12;
  else if (period === KEYS.PERIOD_AM && h === 12) h = 0;

  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(h).padStart(2, '0');
  const min = String(m).padStart(2, '0');
  const offset = timezone.key.replace(KEYS.TIMEZONE_PREFIX, '');
  return `${yyyy}-${mm}-${dd}T${hh}:${min}:00${offset}`;
}

export function parseTimeFromISO(iso: string, defaultTimezone: SelectItem): ToISOTimeParams {
  if (!iso) {
    return { hour: '12', minute: '00', period: KEYS.PERIOD_AM, timezone: defaultTimezone };
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, timePartWithOffset] = iso.split('T');
  if (!timePartWithOffset) return { hour: '12', minute: '00', period: KEYS.PERIOD_AM, timezone: defaultTimezone };
  const [timePart] = timePartWithOffset.split(/([+-])/);
  const offsetMatch = iso.match(/([+-]\d{2}:\d{2})$/);
  const offset = offsetMatch?.[1] ?? '+00:00';
  const [rawHour, rawMinute] = timePart.split(':');
  let hour = parseInt(rawHour || '0', 10);
  const minute = rawMinute || '00';
  const period: Period = hour >= 12 ? KEYS.PERIOD_PM : KEYS.PERIOD_AM;
  hour = hour % 12 || 12;
  return {
    hour: String(hour),
    minute,
    period,
    timezone: { key: `${KEYS.TIMEZONE_PREFIX}${offset}`, label: `${KEYS.TIMEZONE_PREFIX}${offset}` },
  };
}
